var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutritionBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.5C3.5 12.5 1 14.5 1 15C1 15.5 2.5 15 2.5 15V16.5H4V18H5.5V19.5H7C7 19.5 6.5 20.5 7 21C7.5 21.5 9.5 18.5 9.5 18.5V17.5L18 9.5H19C19 9.5 21 8 21 7.5C21 7 19.5 7.5 19.5 7.5V6H18V4.5H16.5V3H15C15 3 15.5 1 15 1C14.5 1 12.5 3.5 12.5 3.5V4.5L4.5 12.5H3.5Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5L17 8.5",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5L8.5 16",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.5L11 13",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.5L8 13",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionBar);
export default __webpack_public_path__ + "static/media/nutrition-bar.c8dc389f6e06717bb130d33334b3be87.svg";
export { ForwardRef as ReactComponent };